import { css } from "@emotion/css";
import { PlusIcon, ShieldHalvedIcon } from "@octopusdeploy/design-system-icons";
import { borderRadius, space, text, themeTokens } from "@octopusdeploy/design-system-tokens";
import type { ReactNode } from "react";
interface CreatePolicyBannerProps {
    heading: string;
    subHeading: ReactNode;
    cardType: "blank" | "default";
    accessories?: ReactNode;
}
export function PolicyStarterSummaryCard({ heading, subHeading, cardType, accessories }: CreatePolicyBannerProps): ReactNode {
    const icon = <div className={styles.iconContainer}>{cardType === "blank" ? <PlusIcon size={24} color={themeTokens.color.icon.primary}/> : <ShieldHalvedIcon size={24} color={themeTokens.color.chip.outlined.icon.info}/>}</div>;
    return (<div className={styles.container}>
            {icon}
            <div className={styles.starterDetails}>
                <div className={styles.heading}>{heading}</div>
                <div className={styles.subHeading}>{subHeading}</div>
            </div>
            {accessories}
        </div>);
}
const styles = {
    container: css({
        display: "flex",
        alignItems: "center",
        gap: space[12],
        padding: space[12],
        backgroundColor: themeTokens.color.background.secondary.default,
        borderRadius: borderRadius.small,
        border: `1px solid ${themeTokens.color.border.primary}`,
    }),
    iconContainer: css({
        height: space[32],
        width: space[32],
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: themeTokens.color.background.primary.default,
        borderRadius: borderRadius.medium,
        padding: space[4],
    }),
    starterDetails: css({
        display: "flex",
        flexDirection: "column",
        flex: 1,
    }),
    heading: css({
        font: text.body.bold.medium,
        color: themeTokens.color.text.primary,
    }),
    subHeading: css({
        font: text.body.regular.small,
        color: themeTokens.color.text.secondary,
    }),
};
